import { createTheme } from "@mui/material/styles";

// Operations-dashboard dark theme: deep slate surfaces, ember accent.
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#ff8a3d", contrastText: "#1a1108" },
    secondary: { main: "#4dd0e1" },
    success: { main: "#66bb6a" },
    warning: { main: "#ffb74d" },
    error: { main: "#ef5350" },
    background: { default: "#0b0f14", paper: "#121820" },
    divider: "rgba(255, 255, 255, 0.08)",
    text: { primary: "#e6edf3", secondary: "#8b98a5" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily:
      '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h5: { fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontWeight: 700, letterSpacing: "-0.01em" },
    subtitle2: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
    overline: { letterSpacing: "0.12em", fontWeight: 700 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "1px solid rgba(255,255,255,0.06)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(11, 15, 20, 0.85)",
          backdropFilter: "blur(12px)",
          backgroundImage: "none",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          boxShadow: "none",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500 },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: "#1c2632", fontSize: "0.75rem" },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          paddingTop: 2,
          paddingBottom: 2,
        },
      },
    },
  },
});

export default theme;
